// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_gZg","cls2":"FocusedNavView-cls2_MyT FocusedNavView-cls1_gZg"};